import { render, staticRenderFns } from "./PmauPrompts.vue?vue&type=template&id=bd0fc1c2&scoped=true&"
import script from "./PmauPrompts.vue?vue&type=script&lang=js&"
export * from "./PmauPrompts.vue?vue&type=script&lang=js&"
import style0 from "./PmauPrompts.vue?vue&type=style&index=0&id=bd0fc1c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0fc1c2",
  null
  
)

export default component.exports